import { useEffect, useState } from 'react';
import { useAuth } from '../auth/AuthProvider';

/**
 * No llegits de la persona (`users/{uid}.unreadTotal`): el número vermell de la pestanya «Missatges»
 * i de la icona de l'app (API Badging, §20.3). Firestore es carrega només amb sessió iniciada.
 */
export function useUnreadTotal(): number {
  const state = useAuth();
  const uid = state.status === 'signedIn' ? state.user.uid : null;
  const [total, setTotal] = useState(0);

  useEffect(() => {
    if (!uid) { setTotal(0); return; }
    let stop: (() => void) | undefined;
    let alive = true;
    void import('./live').then(({ watchUnreadTotal }) => { if (alive) stop = watchUnreadTotal(uid, setTotal); });
    return () => { alive = false; stop?.(); };
  }, [uid]);

  useEffect(() => {
    // La icona de l'app instal·lada (Android, i iOS amb la PWA a la pantalla d'inici).
    const nav = navigator as Navigator & { setAppBadge?: (n?: number) => Promise<void>; clearAppBadge?: () => Promise<void> };
    if (!nav.setAppBadge) return;
    void (total > 0 ? nav.setAppBadge(total) : nav.clearAppBadge?.())?.catch(() => undefined);
  }, [total]);

  return total;
}
